import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-main-component",
  templateUrl: "./button-main-component.component.html",
  styleUrls: ["./button-main-component.component.scss"],
})
export class ButtonMainComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService
  ) {}

  labelform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() config: any;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_text: string;
  row_id: string;
  labelColor: string;
  black_color: string = "#000000";
  enableCustomColor: boolean = false;

  button_label_color: string;
  button_label_style: any;
  button_button_divider: number;

  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  modalRef?: BsModalRef;
  icon: any;
  trailing_icon: any;
  iconType: number;
  fontSize = "md";
  textAlign = "left";
  isAndroid: boolean;
  light: boolean;
  text_id: any;
  colors: any;
  labelDarkColor: any;
  button_color_item: any = { schemes: { light: {}, dark: {} } };
  button_color_light: any = {};
  button_color_dark: any = {};
  sync = true;
  os_name: string;

  ngOnInit() {
    this.field_id = "lable";
    this.labelform = this.formBuilder.group({
      lableControl: new UntypedFormControl(""),
    });

    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );
  }

  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDRIOD ? true : false;
      this.os_name = this.sync? null: this.isAndroid? 'Android': 'iOS'
      this.colors = this.isAndroid
        ? this.config.scheme_color.color_schema
        : this.config.scheme_color.color_schema_ios;
      if (this.isAndroid) {
        this.button_text = this.button[this.config.id]
          ? this.button[this.config.id]
          : "";

        if (this.config.trailing_icon && this.button.button_trailing_icon) {
          this.trailing_icon = this.builderService.getIcon(
            this.button.button_trailing_icon
          );
        }

        if (this.config.icon && this.button.button_icon) {
          this.icon = this.builderService.getIcon(this.button.button_icon);
        }

        if (
          this.config.font &&
          this.button.button_text_fontsize &&
          this.button.button_text_fontsize[this.text_id]
        ) {
          this.fontSize = this.button.button_text_fontsize[this.text_id];
        }

        if (
          this.config.align &&
          this.button.button_text_align &&
          this.button.button_text_align[this.text_id]
        ) {
          this.textAlign = this.button.button_text_align[this.text_id];
        }

        if (
          this.config.setcolor &&
          this.button.button_color_schema &&
          this.button.button_color_schema.schemes &&
          this.button.button_color_schema.schemes.light &&
          this.button.button_color_schema.schemes.dark &&
          this.button.button_color_schema.schemes.light[this.config.color] &&
          this.button.button_color_schema.schemes.dark[this.config.color]
        ) {
          this.labelColor =
            this.button.button_color_schema.schemes.light[this.config.color];
          this.labelDarkColor =
            this.button.button_color_schema.schemes.dark[this.config.color];
          this.enableCustomColor = true;
        }
      } else {
        this.button_text = this.button[this.config.id]
          ? this.button[this.config.id]
          : "";

        if (this.button.button_trailing_icon_ios) {
          this.trailing_icon = this.builderService.getIcon(
            this.button.button_trailing_icon_ios
          );
        }

        if (this.button.button_icon_ios) {
          this.icon = this.builderService.getIcon(this.button.button_icon_ios);
        }

        if (
          this.config.font &&
          this.button.button_text_fontsize_ios &&
          this.button.button_text_fontsize_ios[this.text_id]
        ) {
          this.fontSize = this.button.button_text_fontsize_ios[this.text_id];
        }
        if (
          this.config.align &&
          this.button.button_text_align_ios &&
          this.button.button_text_align_ios[this.text_id]
        ) {
          this.textAlign = this.button.button_text_align_ios[this.text_id];
        }

        if (
          this.config.setcolor &&
          this.button.button_color_schema_ios &&
          this.button.button_color_schema_ios.schemes &&
          this.button.button_color_schema_ios.schemes.light &&
          this.button.button_color_schema_ios.schemes.dark &&
          this.button.button_color_schema_ios.schemes.light[
            this.config.color
          ] &&
          this.button.button_color_schema_ios.schemes.dark[this.config.color]
        ) {
          this.labelColor =
            this.button.button_color_schema_ios.schemes.light[
              this.config.color
            ];
          this.labelDarkColor =
            this.button.button_color_schema_ios.schemes.dark[this.config.color];
          this.enableCustomColor = true;
        }
      }

      this.labelform = this.formBuilder.group({
        lableControl: new UntypedFormControl(this.button_text),
      });

      if (this.config.text) {
        if (this.config.validation && this.config.validation.required) {
          this.labelform
            .get("lableControl")
            .setValidators([Validators.required]);
        }
      }
    }
  }

  buttonLabel() {
    if (this.labelform.valid) {
      this.button[this.config.id] = this.f.lableControl.value;
      this.updateButtonData();
    }
  }

  get f() {
    if (this.labelform && this.labelform.controls) {
      return this.labelform.controls;
    }
  }

  toggle(event) {
    this.enableCustomColor = event;

    if (this.isAndroid || this.sync) {
      /// Android Settings
      if (this.enableCustomColor) {
        this.labelColor = this.colors.schemes.light[this.config.init_color];
        this.labelDarkColor = this.colors.schemes.dark[this.config.init_color];
        if (
          this.button.button_color_schema &&
          this.button.button_color_schema.schemes
        ) {
          const schemes = this.button.button_color_schema.schemes;
          this.button_color_light = schemes.light;
          this.button_color_light = {
            ...this.button_color_light,
            [this.config.color]: this.labelColor,
          };
          this.button_color_dark = schemes.dark;
          this.button_color_dark = {
            ...this.button_color_dark,
            [this.config.color]: this.labelDarkColor,
          };
          this.button.button_color_schema.schemes = {
            light: { ...this.button_color_light },
            dark: { ...this.button_color_dark },
          };
        } else {
          this.button = {
            ...this.button,
            button_color_schema: {
              schemes: {
                light: { [this.config.color]: this.labelColor },
                dark: { [this.config.color]: this.labelDarkColor },
              },
            },
          };
        }
      } else {
        this.labelColor = null;
        this.labelDarkColor = null;
        delete this.button.button_color_schema.schemes.light[this.config.color];
        delete this.button.button_color_schema.schemes.dark[this.config.color];
      }
    }

    if (!this.isAndroid || this.sync) {
      // IOS SETTINGS
      if (this.enableCustomColor) {
        this.labelColor = this.colors.schemes.light[this.config.init_color_ios];
        this.labelDarkColor =
          this.colors.schemes.dark[this.config.init_color_ios];

        if (
          this.button.button_color_schema_ios &&
          this.button.button_color_schema_ios.schemes
        ) {
          const schemes = this.button.button_color_schema_ios.schemes;
          this.button_color_light = schemes.light;
          this.button_color_light = {
            ...this.button_color_light,
            [this.config.color]: this.labelColor,
          };
          this.button_color_dark = schemes.dark;
          this.button_color_dark = {
            ...this.button_color_dark,
            [this.config.color]: this.labelDarkColor,
          };
          this.button.button_color_schema_ios.schemes = {
            light: { ...this.button_color_light },
            dark: { ...this.button_color_dark },
          };
        } else {
          this.button = {
            ...this.button,
            button_color_schema_ios: {
              schemes: {
                light: { [this.config.color]: this.labelColor },
                dark: { [this.config.color]: this.labelDarkColor },
              },
            },
          };
        }
      } else {
        this.labelColor = null;
        this.labelDarkColor = null;
        delete this.button.button_color_schema_ios.schemes.light[
          this.config.color
        ];
        delete this.button.button_color_schema_ios.schemes.dark[
          this.config.color
        ];
      }
    }
    this.updateButtonData();
  }

  colorChange(value, manual) {
    let color = null;
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.labelColor = this.mdw.customColor(color).light;
      this.labelDarkColor = this.mdw.customColor(color).dark;

      if (this.isAndroid || this.sync) {
        this.button.button_color_schema.schemes.light[this.config.color] =
          this.labelColor;
        this.button.button_color_schema.schemes.dark[this.config.color] =
          this.labelDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.button.button_color_schema_ios.schemes.light[this.config.color] =
          this.labelColor;
        this.button.button_color_schema_ios.schemes.dark[this.config.color] =
          this.labelDarkColor;
      }
      this.updateButtonData();
    }
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  openSelector(exlargeModal: any, type) {
    this.iconType = type;
    this.modalRef = this.modalService.show(exlargeModal, { class: "modal-xl" });
  }

  iconChange(event) {
    if (this.iconType) {
      this.trailing_icon = this.builderService.getIcon(event);
      if (this.isAndroid || this.sync) {
        this.button.button_trailing_icon = event;
      }

      if (!this.isAndroid || this.sync) {
        this.button.button_trailing_icon_ios = event;
      }
    } else {
      this.icon = this.builderService.getIcon(event);
      if (this.isAndroid || this.sync) {
        this.button.button_icon = event;
      }
      if (!this.isAndroid || this.sync) {
        this.button.button_icon_ios = event;
      }
    }
    this.updateButtonData();
    this.modalRef.hide();
  }

  updateFontSize(fontSize) {
    this.fontSize = fontSize;
    if (this.isAndroid || this.sync) {
      this.button = {
        ...this.button,
        button_text_fontsize: {
          ...this.button.button_text_fontsize,
          [this.config.font_key]: fontSize,
        },
      };
    }
    if (!this.isAndroid || this.sync) {
      this.button = {
        ...this.button,
        button_text_fontsize_ios: {
          ...this.button.button_text_fontsize_ios,
          [this.config.font_key]: fontSize,
        },
      };
    }
    this.updateButtonData();
  }

  updateLapleAlignmet(alignment) {
    this.textAlign = alignment;
    if (this.isAndroid || this.sync) {
      this.button = {
        ...this.button,
        button_text_align: {
          ...this.button.button_text_align,
          [this.config.align_key]: alignment,
        },
      };
    }
    if (!this.isAndroid || this.sync) {
      this.button = {
        ...this.button,
        button_text_align_ios: {
          ...this.button.button_text_align_ios,
          [this.config.align_key]: alignment,
        },
      };
    }
    this.updateButtonData();
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
}
